/**
 * dd/mm/yyyy hh:mm
 */
export function stringToDate(str: string): Date {
  const [dateValues, timeValues] = str.split(' ')

  const [day, month, year] = dateValues.split('/')
  const [hours, minutes] = timeValues.split(':')

  const date = new Date(+year, +month - 1, +day, +hours, +minutes, 0)

  return date
}

/**
 * Split dd/mm/yyy into array
 *
 * @return an array of date properties [day, month, year]
 */
export function splitDateString(str: string): string[] {
  return str.trim().split('/')
}

/**
 *
 * @param d Date
 * @returns an object of `date` and `time` in string
 */
export function splitDateTime(d: Date): { date: string; time: string } {
  const date =
    ('0' + d.getDate()).slice(-2) +
    '/' +
    ('0' + (d.getMonth() + 1)).slice(-2) +
    '/' +
    d.getFullYear()
  const time =
    ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
  return { date: date, time: time }
}

interface IDate {
  day: string
  month: string
  year: string
  hour: string
  minute: string
}
/**
 * @return current date in object format {date, month, year, hour, minute}
 */
export function getCurrentDateArray(): IDate {
  // dd/mm/yyyy order
  const now = new Date()

  return {
    day: ('0' + now.getDate()).slice(-2),
    month: ('0' + (now.getMonth() + 1)).slice(-2),
    year: ('0' + now.getFullYear()).slice(-4),
    hour: ('0' + now.getHours()).slice(-2),
    minute: ('0' + now.getMinutes()).slice(-2),
  }
}

/**
 * Convert date for UI
 */
export function dateToStringForUI(date: Date): string {
  let result = date.toLocaleDateString()

  const dateSplit = date.toLocaleString().replace('/', '|')
  const timeSplit = dateSplit.toLocaleString().replace(', ', '|')
  const dateArray = timeSplit.split('|')
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const month_index = parseInt(dateArray[1], 10) - 1
  result =
    dateArray[0] +
    ' ' +
    months[month_index] +
    ' ' +
    dateArray[2] +
    ' ' +
    dateArray[3].toString().slice(0, -3)

  return result
}
